export default __webpack_public_path__ + "static/media/friendly02.3e68bc8e.png";